'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// this component exists for the stepper
var HalfCircle = function (_PureComponent) {
  _inherits(HalfCircle, _PureComponent);

  function HalfCircle() {
    _classCallCheck(this, HalfCircle);

    return _possibleConstructorReturn(this, (HalfCircle.__proto__ || Object.getPrototypeOf(HalfCircle)).apply(this, arguments));
  }

  _createClass(HalfCircle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          width = _props.width,
          className = _props.className,
          color = _props.color,
          outline = _props.outline,
          backgroundColor = _props.backgroundColor,
          direction = _props.direction;

      var directions = {
        top: 90,
        left: 0,
        bottom: 270,
        right: 180
      };
      return _react2.default.createElement(
        'svg',
        {
          className: className,
          width: width,
          height: width,
          viewBox: '0 0 24 24',
          transform: 'rotate(' + directions[direction] + ')'
        },
        _react2.default.createElement('path', { fill: color, d: 'M11.9,0H12V24h-.1a12,12,0,0,1,0-24Z', transform: 'translate(0 0.02)' }),
        _react2.default.createElement('path', { fill: backgroundColor, d: 'M12.1,0H12V24h.1a12,12,0,0,0,0-24Z', transform: 'translate(0 0.02)' }),
        _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', fill: 'none', stroke: outline })
      );
    }
  }]);

  return HalfCircle;
}(_react.PureComponent);

exports.default = HalfCircle;


HalfCircle.propTypes = {
  color: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string,
  className: _propTypes2.default.string,
  outline: _propTypes2.default.string,
  direction: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'right']),
  width: _propTypes2.default.number
};

HalfCircle.defaultProps = {
  color: '',
  backgroundColor: 'white',
  className: 'default',
  outline: _colors.alloy,
  direction: 'left',
  width: 14
};